// Use relative path in production (nginx proxy) or full URL in development
const { REACT_APP_HOST, REACT_APP_PORT } = process.env;

// In production build or when REACT_APP_HOST is not set, use relative paths (nginx will proxy to backend)
// In development, use full URL to backend
const API_URL = REACT_APP_HOST && REACT_APP_PORT 
  ? `${REACT_APP_HOST}:${REACT_APP_PORT}/api` 
  : '/api';

const authURL = `${API_URL}/auth`;
const queryParcelURL = `${API_URL}/queryparcel`;
const queryParcelFeatureURL = `${API_URL}/queryparcelfeature`;
const queryVillagesURL = `${API_URL}/queryvillages`;
const agrementURL = `${API_URL}/static/SPOT_SON_KULLANICI_LISANS_SOZLESMESI_ENG_TR.pdf`;

export {
  queryParcelURL,
  queryParcelFeatureURL,
  queryVillagesURL,
  agrementURL,
  authURL,
};
